import { SymbolQuote } from '@tradingblock/api';
import { formatNumber, Loading } from '@tradingblock/components';
import React, { FC, useRef } from 'react';
import { useStateSelector } from '../../data/global/dataSelectors';
import { getQuoteMetadata } from '../../data/global/selectors/quoteSelector';
import { useDashboardSettings } from '../../hooks/useDashboardSettings';
export interface DashboardSymbolWidgetProps {
  symbol?: string;
}
const centeringStyle = { paddingLeft: '1rem', alignItems: 'center' };
const widgetSymbolsStyle = { color: 'ghostwhite', fontWeight: 'bold' } as object; //very strange necessary cast

export const DashboardSymbolWidget: FC<DashboardSymbolWidgetProps> = ({ symbol }): JSX.Element => {
  const quote: SymbolQuote = useStateSelector(s => getQuoteMetadata(s, symbol ? symbol : ''));
  const changePercentStyle = { color: quote && quote.NetChange > 0.0 ? 'var(--teal)' : 'var(--salmon)' };
  const { showBannerSymbols } = useDashboardSettings();
  const widgetContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    fontSize: `0.75rem`,
    ...centeringStyle,
  } as object;

  const change = useRef(0.0);

  if (quote && quote.NetChange) {
    change.current = quote.NetChange ? quote.NetChange : 0.0;
  }

  const widgetCells = quote ? (
    <span style={widgetContainerStyle}>
      <span style={widgetSymbolsStyle}>
        {symbol}
        &nbsp;
        {formatNumber(quote.LastOrClosePrice, { currency: true }).replace('$', '')}&nbsp;
        <span style={changePercentStyle}>
          {change.current && (
            <i className={`fas fa-xs fa-triangle ${change.current < 0.0 ? 'fas fa-flip-vertical' : ''}`}></i>
          )}
          {formatNumber(change.current)}
        </span>
      </span>
    </span>
  ) : (
    <div style={{ ...centeringStyle, ...widgetContainerStyle, fontSize: 'inherit' }}>
      <Loading size="small" />
    </div>
  );
  if (!showBannerSymbols) return <></>;
  else return widgetCells;
};
